import * as THREE from 'three';

export { Scene } from './Scene.js';
export { Obstacle } from './Obstacle.js';
export { Projectile } from './Projectile.js';
export { Explosion } from './Explosion.js';
export { HealthPack } from './HealthPack.js';
export { BuyZone } from './BuyZone.js';
export { Tank } from './Tank.js';
export { Airplane } from './Airplane.js';
export { Player } from './Player.js';
export { Sniper } from './Sniper.js';
export { RocketLauncher } from './RocketLauncher.js';
export { Turret } from './Turret.js';
export { Barracks } from './Barracks.js';

// Sleek sci-fi: neon-lit alloy arena, hover tanks and drones under a night sky
export const id = 'futuristic';
export const icon = '🚀';
export const name = 'Futuristic';

export function configureRenderer(renderer) {
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.setClearColor(0x05070d);
}

// Called on every entity's root object after it is built
export function prepare() {}

export const strings = {
  subtitle: 'Real-time 3D sci-fi strategy',
  about: 'Arena Game is a real-time 3D multiplayer strategy game where two commanders battle for supremacy using hover tanks, gunship drones, and pulse turrets.',
  units: {
    tank: 'Hover Tank',
    airplane: 'Gunship Drone',
    super_tank: 'Siege Walker',
    super_helicopter: 'Dreadnought',
    sniper: 'Railgunner',
    rocket_launcher: 'Siege Drone'
  },
  iconTank: '🛸',
  iconHelicopter: '🛰️',
  tanks: 'Hover Tanks',
  helicopters: 'Drones',
  money: amount => `⚡${amount}`,
  notEnoughMoney: 'Not enough credits',
  buy: 'deploy',
  waitingToSpawn: 'in fabrication...',
  forwardBase: 'Relay Outpost',
  turret: 'Pulse Turret',
  barracks: 'Clone Bay',
  shoot: 'Fire',
  buyClaim: 'Deploy/Claim',
  bulkBuy: 'Deploy a squadron (10 units)',
  bulkBuyShort: 'Squadron (10)',
  statTanks: 'Hover Tanks',
  statHelicopters: 'Drones',
  statSnipers: 'Railgunners',
  statRockets: 'Siege Drones',
  statTurrets: 'Pulse Turrets',
  statBarracks: 'Clone Bays',
  statPlayer: 'Commander'
};

// Rewording of the server's plain messages
export const messages = [
  [/Tank captured enemy base/g, 'Hover Tank breached the enemy core'],
  [/Need \$(\d+)/g, 'Need ⚡$1'],
  [/money/g, 'credits'],
  [/Bulk purchase only available for tanks and helicopters/g, 'Squadrons are only available for hover tanks and drones'],
  [/Super Tank/g, 'Siege Walker'],
  [/Super Helicopter/g, 'Dreadnought'],
  [/buy zone/g, 'fabricator'],
  [/purchase/g, 'deploy units'],
  [/Turret/g, 'Pulse turret'],
  [/turret/g, 'pulse turret'],
  [/ a base/g, ' a relay outpost'],
  [/base/g, 'relay outpost'],
  [/Barracks/g, 'Clone bay'],
  [/barracks/g, 'clone bay']
];
